export default "__VITE_ASSET__8f8f4b6b__"